module.exports = __webpack_public_path__ + "static/media/slider-live-img.94922526.png";